import React from 'react';
import logo from './logo.svg';
import './App.css';

import {GoogleCharts} from 'google-charts';

function App() { 

	window.onload = function () {
		//drawChart();
	};

	//GoogleCharts.load(drawChart);
	GoogleCharts.load(drawChart, {
		'packages': ['gauge']
	});

	return (
	  <div className="App">
		<header className="App-header">
		  <p> HEADER </p>
		</header>

		<div className="MainContainer">

			<div className="Collumn1 CommonBlock">
				<p> Block 1 </p>
			</div>

			<div className="Collumn2">

					<div className="Collumn2Row1 CommonBlock">
						<div className="">
							<p>Block 2 Title</p>
						</div>
						<div className="">
							<div id="GaugeTemp1">
							</div>
							<div id="GaugeTemp2">
							</div>
						</div>
						
					</div>

					<div className="Collumn2Row2 CommonBlock">
						<p> Block 3 </p>
					</div>			

			</div>

			<div className="Collumn3 CommonBlock">
				<p> Block 4 </p>
			</div>
		</div>

	  </div>
	);
  }

function setCallBack() {
	
}

function drawChart() {
	/* const data = GoogleCharts.api.visualization.arrayToDataTable([
        ['Label', 'Value'],
		['Temp 1', 80],		
	]);
 */
	const data = new GoogleCharts.api.visualization.DataTable();
	data.addColumn('string', 'Label');
	data.addColumn('number', 'Value');
	data.addRow(["Temp1", 10]);
	data.addRow(["Temp2", 10]);

	var options = {
		width: 600, height: 100,
		redFrom: 80, redTo: 100,
		yellowFrom:60, yellowTo: 80,
		greenFrom: 0, greenTo: 60,
		minorTicks: 10,
		animation:{
			duration: 1000,
			easing: 'inAndOut',
		  }
	  };

    const chart = new GoogleCharts.api.visualization.Gauge(document.getElementById('GaugeTemp1'));
	chart.draw(data);

	setInterval(function() {
		data.setValue(0, 1, 40 + Math.round(60 * Math.random()));
		chart.draw(data, options);
	  }, 1000);
  }

export default App;
